import { useSiteData } from '@/context/SiteDataProvider'
import Head from 'next/head'
import { useRouter } from 'next/router'

const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'https://www.integrityxd.com'

export default function SEO({ title, description, imageUrl, url }) {
  const {
    settings: { title: siteTitle, description: siteDescription }
  } = useSiteData()
  const { asPath } = useRouter()

  const metaTitle = title || siteTitle
  const metaDescription = description || siteDescription
  const canonicalUrl = url || `${SITE_URL}${asPath.split(/[?#]/)[0]}`

  return (
    <Head>
      <meta property="og:type" content="website" />
      <meta property="twitter:card" content="summary_large_image" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hrefLang="en" href={canonicalUrl} />
      <link rel="alternate" hrefLang="x-default" href={canonicalUrl} />

      {metaTitle && (
        <>
          <title>{metaTitle}</title>
          <meta name="title" content={metaTitle} />
          <meta property="og:title" content={metaTitle} />
          <meta property="twitter:title" content={metaTitle} />
        </>
      )}

      {metaDescription && (
        <>
          <meta name="description" content={metaDescription} />
          <meta property="og:description" content={metaDescription} />
          <meta property="twitter:description" content={metaDescription} />
        </>
      )}

      {imageUrl && (
        <>
          <meta property="og:image" content={imageUrl} />
          <meta property="twitter:image" content={imageUrl} />
        </>
      )}

      {canonicalUrl && (
        <>
          <meta property="og:url" content={canonicalUrl} />
          <meta property="twitter:url" content={canonicalUrl} />
        </>
      )}
    </Head>
  )
}
